module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stream-container"
  }, [_c('div', {
    staticClass: "jumbotron flex-one mr-2"
  }, [_c('h4', [_vm._v("Stream Stats")]), _vm._v(" "), _c('p', [_vm._v("State: " + _vm._s((_vm.streaming) ? 'Streaming' : 'Not Streaming'))]), _vm._v(" "), _c('stream-timer', {
    attrs: {
      "total-seconds": _vm.totalSeconds
    }
  }), _vm._v(" "), _c('p', [_vm._v("Number of Tweets: " + _vm._s(_vm.statusListLength))]), _vm._v(" "), _c('p', [_vm._v("Language: " + _vm._s(_vm.language))]), _vm._v(" "), _c('p', [_vm._v("Track String: " + _vm._s(_vm.trackString))])], 1), _vm._v(" "), _c('div', {
    staticClass: "jumbotron flex-three"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.canStartStream
    },
    on: {
      "click": _vm.startStreamHandler
    }
  }, [_vm._v("Start Stream")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.streaming
    },
    on: {
      "click": _vm.stopStreamHandler
    }
  }, [_vm._v("Stop Stream")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center mt-4 filter-container"
  }, [_c('p', [_vm._v("Search by Name, Username or Tweet Text")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filter"
    },
    domProps: {
      "value": _vm.filterString
    },
    on: {
      "input": _vm.setFilterString
    }
  }), _vm._v(" "), (_vm.filterString) ? _c('p', [_vm._v(" Filter Results: " + _vm._s(_vm.filterArray.length))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3118d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stream.vue
// module id = 24
// module chunks = 0